import {PBChannel} from "@irati/types"

export default PBChannel.Web
